import {
  put, all, call, select, takeLatest,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { exception } from 'circe/logger';
import { delay } from 'redux-saga';
import { fetch } from './actions';
import { fetched, fetching } from '../actions';
import { fetch as fetchApi } from './api';

function* doFetch() {
  try {
    const state = yield select();

    const headers = yield call(getCurrentAuthHeader, state);

    let allShipments = [];

    let resp = yield call(fetchApi, null, headers);

    if (!resp) {
      throw new Error('My Shipments failed to load');
    }

    yield put(fetched(resp.results));

    allShipments = allShipments.concat(resp.results);

    while (resp.nextPage && resp.nextPage.hasResults) {
      yield delay(750);

      resp = yield call(fetchApi, resp.nextPage.cursor, headers);

      allShipments = allShipments.concat(resp.results);

      yield put(fetched(allShipments));
    }
  } catch (e) {
    exception(e);
  }
}

export default function* () {
  yield all([takeLatest(fetch().type, doFetch)]);
}
